import { render, staticRenderFns } from "./LeadsTable.vue?vue&type=template&id=edb95adc&scoped=true"
import script from "./LeadsTable.vue?vue&type=script&lang=js"
export * from "./LeadsTable.vue?vue&type=script&lang=js"
import style0 from "./LeadsTable.vue?vue&type=style&index=0&id=edb95adc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb95adc",
  null
  
)

export default component.exports